import { MessageBundle } from '@amzn/arb-tools';
import { token } from '@amzn/stencil-design-tokens/js/web/utils';
import { ReactNode } from 'react';
import { t } from 'src/helpers';

export const highlightedText = (
  bundle: MessageBundle,
  prefixStringId: string,
  highlightStringId: string,
  postfixStringId: string,
): ReactNode => (
  <>
    {t(bundle, prefixStringId)}{' '}
    <span style={{ color: token('color.text.accent-on-bg-default') }}>
      {t(bundle, highlightStringId)}
    </span>{' '}
    {t(bundle, postfixStringId)}
  </>
);
